import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CursorPaginationInput } from '@app/data/inputs';
import { CollectionResource } from '@app/data/resources';
import { TaskMessageFilterInput, CreateTaskMessageInput, UpdateTaskMessageInput } from './inputs';
import { TaskMessageRef } from './refs';
import { TaskMessageResource, TaskMessageListItemResource } from './resources';

export default class TaskMessage {
    private basePath = '/api/task-message';
    private http;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get task message list
    get = async (
        pagination: CursorPaginationInput,
        filter: TaskMessageFilterInput
    ): Promise<CollectionResource<TaskMessageListItemResource, {}>> => {
        const query = qs.stringify({ ...pagination, ...filter });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Fetch single task message
    getById = async (id: ID): Promise<TaskMessageResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);

        return data;
    };

    // Create new task message
    create = async (input: CreateTaskMessageInput): Promise<TaskMessageRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);

        return data;
    };

    // Update message
    update = async (id: ID, input: UpdateTaskMessageInput): Promise<TaskMessageRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}`, input);

        return data;
    };

    // Archive task message
    archive = async (id: ID): Promise<TaskMessageRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}`);

        return data;
    };

    // Restore archived task message
    restore = async (id: ID): Promise<TaskMessageRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/restore`);

        return data;
    };

    // Pin message
    pin = async (id: ID): Promise<TaskMessageRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/pin`);

        return data;
    };

    // Unpin message
    unpin = async (id: ID): Promise<TaskMessageRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}/pin`);

        return data;
    };
}
